import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { scrollToId } from "@/lib/scroll";

const DEV_IMG =
  "https://images.pexels.com/photos/25461690/pexels-photo-25461690.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export const Development = () => (
  <section id="development" data-testid="development-section" className="relative overflow-hidden py-24 sm:py-32">
    <div className="absolute inset-0">
      <img
        src={DEV_IMG}
        alt="Architectural property development — modern residential structure"
        className="h-full w-full object-cover"
      />
      <div className="absolute inset-0 bg-[#050B14]/90" />
    </div>
    <div className="relative mx-auto max-w-4xl px-5 text-center sm:px-8">
      <Reveal>
        <div className="mb-6 flex items-center justify-center gap-4">
          <span className="h-px w-12 bg-gradient-to-r from-transparent to-[#C5A059]" />
          <span className="text-[11px] font-semibold uppercase tracking-[0.35em] text-[#C5A059]">Property Development</span>
          <span className="h-px w-12 bg-gradient-to-l from-transparent to-[#C5A059]" />
        </div>
        <h2 className="font-serif text-3xl font-light uppercase leading-snug tracking-tight text-white sm:text-4xl lg:text-5xl">
          More Than <span className="gold-text-gradient">Construction.</span>
        </h2>
      </Reveal>
      <Reveal delay={0.15}>
        <p className="mx-auto mt-8 max-w-2xl text-base font-light leading-relaxed text-slate-300 sm:text-lg">
          Our experience in property services is built around a wider understanding of
          property — from renovation and construction through to value creation and
          development.
        </p>
        <p className="mx-auto mt-5 max-w-2xl text-base font-light leading-relaxed text-slate-400">
          Tyrell Property Services is building the foundations for a wider property
          development business, focused on identifying opportunities, improving properties
          and creating long-term value.
        </p>
        <button
          data-testid="discuss-project-button"
          onClick={() => scrollToId("#contact")}
          className="group mt-10 inline-flex items-center gap-3 border border-[#C5A059] px-9 py-4 text-xs font-semibold uppercase tracking-[0.25em] text-[#C5A059] transition-all duration-300 hover:bg-[#C5A059] hover:text-[#050B14]"
        >
          Discuss a Project
          <ArrowRight size={15} className="transition-transform duration-300 group-hover:translate-x-1" />
        </button>
      </Reveal>
    </div>
  </section>
);
